import React, {Component} from 'react'
import confirmDialog from "../../../components/dialog/ConfirmDialog";
import ValidationUtil from "../../../components/form/validator/ValidationUtil";
import RemotingService from "../../../services/remoting-service/RemotingService";
import {TextInput, Wizard} from "../../../components";
import FormField from "../../../components/form/FormField";
import SignatureInput from "../../../components/signature-input/SignatureInput";
import ConsentFormsUtil from "../utils/ConsentFormsUtil";
import ClinicLogo from "../../../layout/ClinicLogo";

export default class PublicShockwaveTherapyConsentForm extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    createHeader = (form) => {
        return <div style={{padding: "0px 20px 0px 20px"}}>
            <div className="row text-left">
                <div className="col-12 no-padding">
                    <ClinicLogo/>
                </div>
            </div>
            <div className="row">
                <div className="col-12 text-center no-padding" style={{fontSize: 20, fontWeight: "bold"}}>
                    SHOCKWAVE THERAPY CONSENT FORM
                </div>
            </div>
            <div className="row" style={{fontSize: 11}}>
                <div className="col-4 text-left no-padding">
                    <b>Patient Name: </b> {form.patientFullName}
                </div>
                <div className="col-4 text-center no-padding">
                    <b>MRN No: </b> {form.patientMrn}
                </div>

                <div className="col-4 text-right no-padding">
                    <b>D.O.B: </b> {form.patientDOB}
                </div>
            </div>
        </div>
    };

    fieldChanged = (fieldName, value) => {
        this.props.form[fieldName] = value;
        this.forceUpdate();
    };

    close = () => {
        confirmDialog(
            'Confirmation',
            'Are you sure you want to close this form? All input will be lost.',
            this.props.close);
    };

    submitForm = () => {
        if (ValidationUtil.checkWithNotification(this.formFields)) {
            const {consentFormCode: code, form} = this.props;
            RemotingService.postRemoteCall(`api/public/consent-form/code/${code}/shockwave-therapy-consent-form`, form);
            this.props.onFormSubmit(form);
        }
    };

    render() {
        this.formFields = [];
        const {form} = this.props;
        return (
            <Wizard
                show={true} fullScreen
                footerStyle={{backgroundColor: '#f5f5f5'}}
                buttonStyle={{backgroundColor: '#84BE56', border: 'none'}}
                header={this.createHeader(form)}
                close={this.close}
                onSubmit={this.submitForm}>

                <Wizard.Page onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}>
                    <div style={{margin: "20px"}}>

                        <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                            <div style={{margin: "15px 15px"}}>
                                <h6>
                                    <b>Shockwave Therapy</b>
                                </h6>
                                <p>
                                    Shockwave therapy is a non-invasive treatment in which a
                                    device is used to pass acoustic shockwaves through the skin to
                                    the affected area, it can be utilized in the treatment of
                                    tendon pathology.
                                </p>
                            </div>
                        </div>

                        <div className="p-3" style={{border: "1px solid #000000"}}>
                            <h6>
                                <b>Statement of Health Professional: </b>
                            </h6>
                            <p>
                                (to be filled in by health professional with appropriate
                                knowledge of proposed investigation){" "}
                            </p>
                            <p>
                                I have explained the procedure to the patient, in particular:
                            </p>
                            <p>
                                Shockwave therapy is a non-invasive treatment that involves
                                delivery of shock waves to injured soft tissue to reduce pain
                                and promote healing It stimulates the body’s own healing
                                mechanisms to facilitate repair. The treatment produces an
                                inflammatory response and the body responds by increasing
                                metabolic activity around the site of pain. This stimulates and
                                accelerates the healing process. Shockwave breaks down scar
                                tissue and possibly calcification as well and the transmission
                                of pain is blocked.
                            </p>
                            <p>
                                It is a short treatment (usually five to twenty minutes) that
                                may be uncomfortable. However, the procedure is usually
                                tolerated well by most people
                            </p>
                            <p>
                                There may or may not be immediate pain, but some discomfort may
                                be experienced 2-4 hours after the treatment. In some cases, it
                                can last up to 48 hours and in very rare cases, the pain may
                                last up to 5 days.
                            </p>
                            <h6>
                                <b>Benefits</b>
                            </h6>
                            <p>
                                There may be immediate reduction of pain and improved ease of
                                movement.
                            </p>

                            <h6>
                                <b>Side effects</b>
                            </h6>
                            <article className="d-flex w-75 ">
                                <u className="mr-2">Common:</u>
                                <p>
                                    <b>
                                        Mild redness, bruising, swelling, pain, numbness, skin
                                        damage
                                    </b>{" "}
                                    or tingling in the treated area. An increase in pain in the
                                    treated area.
                                </p>
                            </article>
                            <article className="d-flex w-75 ">
                                <u className="mr-2">Very Rare:</u>
                                <p>Tendon tear or rupture</p>
                            </article>
                        </div>
                    </div>
                    <div style={{margin: "20px"}} className={"container"}>
                        <div className={"row"} style={{marginTop: "10px"}}>
                            <div className="col-md-3 dim14-form-label">
                                Provider Name
                            </div>
                            <div className="col-md-3 dim14-base-input">
                                {": " + (form.providerName ? form.providerName : " ")}
                            </div>

                            <div className="col-md-3 dim14-form-label">
                                Job Title
                            </div>
                            <div className="col-md-3 dim14-base-input">
                                {": " + (form.providerSpeciality ? form.providerSpeciality : " ")}
                            </div>
                        </div>

                        <div className={"row"} style={{marginTop: "10px"}}>
                            <div className="col-md-3 dim14-form-label">
                                Date/Time
                            </div>
                            <div className="col-md-3 dim14-base-input">
                                {": " + ConsentFormsUtil.formatSignatureDateTime(form.healthProfessionalDate)}
                            </div>

                            <div className="col-md-6">
                                <div className="col-md-12 dim14-form-label">
                                    Signature of Provider
                                </div>

                                <div className="col-md-12">
                                    <FormField
                                        ref={(ref) => this.formFields.push(ref)}
                                        required requiredMessage="Signature required"
                                        validateOn={form.providerSignature}
                                    >
                                        <SignatureInput signature={form.providerSignature}
                                                        onClear={() => {
                                                            form.providerSignature = null;
                                                            this.forceUpdate();
                                                        }}
                                                        onSave={(signature) => {
                                                            form.providerSignature = signature;
                                                            this.forceUpdate();
                                                        }}/>
                                    </FormField>
                                </div>
                            </div>
                        </div>
                    </div>
                </Wizard.Page>

                <Wizard.Page onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                             onPrevious={() => this.formFields = []}>

                    <div style={{margin: "20px 20px 20px 20px"}}>
                        <div className="p-3" style={{border: "1px solid #000000"}}>
                            <h6>
                                <b>Statement of patient:</b>
                            </h6>
                            <p>
                                Please read this form carefully. If you have any further
                                questions, do ask. You have the right to change your mind at any
                                time, including after you have signed this form.
                            </p>
                            <h6>
                                <b>
                                    I <b>understand</b> and agree to the following:
                                </b>
                            </h6>
                            <ul>
                                <li>
                                    <p>
                                        I <b>understand</b> the investigation which has been
                                        explained to me.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        I <b>understand</b> that I can terminate the procedure at
                                        any time.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        I <b>understand</b> that I am responsible for immediately
                                        telling the examiner if I am having any discomfort or
                                        unusual symptoms during the procedure and if I wish to
                                        terminate the examination or treatment.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        I <b>understand</b> that I may experience pain after the
                                        procedure. The shockwave will trigger an inflammatory
                                        response, which is the body’s natural process of healing.
                                        For this reason, <b>I have been instructed</b> to not use
                                        anti-inflammatory medications. Not use ice. The pain should
                                        subside within 24 hours.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        I <b>verify</b> that I have not had a steroid injection in
                                        the past month or take anti-coagulant therapy
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        I <b>understand</b> that the person performing the
                                        investigation has the appropriate experience or is training
                                        under direct supervision.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        I <b>agree</b> that I have had a chance to ask appropriate
                                        questions.
                                    </p>
                                </li>
                            </ul>

                            <p>
                                I have <b>informed</b> my Clinician that I <b>DO NOT HAVE</b> a
                                tendency to hemorrhage, Hemophilia, acute inflammation of the
                                treatment area, tumor at the treatment site, infection of the
                                treatment area, pregnant, severe circulatory disorder, nerve
                                disorder at treatment site, open wound at the treatment site,
                                prosthesis or any other condition that may contraindicate this
                                treatment.
                            </p>
                        </div>

                        <div className="container">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-6 dim14-form-label">
                                            Date/Time
                                        </div>
                                        <div className="col-md-6 dim14-base-input">
                                            {": " + ConsentFormsUtil.formatSignatureDateTime(form.patientDate)}
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 dim14-form-label">
                                            Patient Name
                                        </div>
                                        <div className="col-md-6 dim14-base-input">
                                            {": " + form.patientFullName}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="col-md-12 dim14-form-label">
                                        Signature of Patient
                                    </div>

                                    <div className="col-md-12">
                                        <SignatureInput signature={form.patientSignature}
                                                        onClear={() => {
                                                            form.patientSignature = null;
                                                            this.forceUpdate();
                                                        }}
                                                        onSave={(signature) => {
                                                            form.patientSignature = signature;
                                                            this.forceUpdate();
                                                        }}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Wizard.Page>

                <Wizard.Page onPrevious={() => this.formFields = []}>

                    <div style={{margin: "20px 20px 20px 20px"}}>
                        <div className={"row"}>
                            <p><b>A witness should sign below if the patient is unable to sign but has indicated
                                his or her consent. <br/>
                                Young people (under {ConsentFormsUtil.getWitnessAgeText()} years of age) and children should also have a Parent
                                or Guardian sign here.</b></p>
                        </div>
                        <div className={"container"}>
                            <div className={"row"} style={{marginTop: "10px"}}>
                                <div className="col-md-3 dim14-form-label">
                                    Print Name
                                </div>
                                <div className="col-md-3 dim14-base-input">
                                    <TextInput value={form.guardianName} alphabeticOnly
                                               onChange={(value) => this.fieldChanged('guardianName', value)}/>
                                </div>

                                <div className="col-md-3 dim14-form-label">
                                    Relationship to Patient
                                </div>
                                <div className="col-md-3 dim14-base-input">
                                    <TextInput value={form.guardianRelationship} alphabeticOnly
                                               onChange={(value) => this.fieldChanged('guardianRelationship', value)}/>
                                </div>
                            </div>

                            <div className={"row"} style={{marginTop: "10px"}}>
                                <div className="col-md-3 dim14-form-label">
                                    Date/Time
                                </div>
                                <div className="col-md-3 dim14-base-input">
                                    {": " + ConsentFormsUtil.formatSignatureDateTime(form.guardianDate)}
                                </div>

                                <div className="col-md-6">
                                    <div className="col-md-12 dim14-form-label">
                                        Signature of Witness/Parent or Guardian
                                    </div>

                                    <div className="col-md-12">
                                        <FormField
                                            ref={(formField) => this.formFields.push(formField)}
                                            disabled={form.patientSignature != null}
                                            required requiredMessage="Signature required"
                                            validateOn={form.guardianSignature}
                                        >
                                            <SignatureInput signature={form.guardianSignature}
                                                            onClear={() => {
                                                                form.guardianSignature = null;
                                                                this.forceUpdate();
                                                            }}
                                                            onSave={(signature) => {
                                                                form.guardianSignature = signature;
                                                                this.forceUpdate();
                                                            }}/>
                                        </FormField>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Wizard.Page>
            </Wizard>
        )
    }
}
